import styled from 'styled-components';

export const Container = styled.div`
  text-align: center;
  margin: 15px;
  display: flex;
  flex-direction: column;
  max-width: 700px;
  width: 100%;

  a{
    color: white;
    text-decoration: none;
    background-color: #8a2be2;
    padding: 8px;
    border-radius: 8px;
    align-self: flex-start;
  }
`;